import { render } from "./ClientsTable.vue?vue&type=template&id=4ef17738&scoped=true"
import script from "./ClientsTable.vue?vue&type=script&lang=js"
export * from "./ClientsTable.vue?vue&type=script&lang=js"

import "./ClientsTable.vue?vue&type=style&index=0&id=4ef17738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef17738"]])

export default __exports__